import { FC } from "react";
import { BrowserRouter, Route, Routes } from "react-router";

import { OverlayContainer, TooltipContainer } from "capitalrx-components-2.0/lib/general";

import { ExternalLinkModalProvider } from "@/basic/context";
import { ExternalLinkGuard, ExternalLinkModal } from "@/common/components/ExternalLinkModal";
import {
  FindPharmacies,
  MedicarePrescriptionPaymentPlan,
  Pharmacies,
  PharmacyDetailsPage,
  Plan,
  PlanDetailsPage,
  PlanSelect,
  PlansPage,
  ComparePlansPage,
  PrintPharmaciesPage,
} from "@/premium/pages";
import { enablePlansPageRedesign } from "@/utils/featureFlags";

export const PremiumRoutes: FC = (): JSX.Element => {
  return (
    <BrowserRouter>
      <OverlayContainer>
        <TooltipContainer>
          <ExternalLinkModalProvider>
            <ExternalLinkGuard />
            <ExternalLinkModal />
            <Routes>
              <Route path="/" element={<PlanSelect />} />
              {enablePlansPageRedesign() && <Route path="/plans" element={<PlansPage />} />}
              {enablePlansPageRedesign() && <Route path="/compare-plans" element={<ComparePlansPage />} />}
              <Route path="/plan" element={<Plan />} />
              {enablePlansPageRedesign() && <Route path="/plan-details" element={<PlanDetailsPage />} />}
              <Route path="/plan/medicare-prescription-payment-plan" element={<MedicarePrescriptionPaymentPlan />} />
              <Route path="/plan/find-pharmacies/pharmacies/pharmacy-details" element={<PharmacyDetailsPage />} />
              <Route path="/plan/find-pharmacies/pharmacies" element={<Pharmacies />} />
              <Route path="/plan/find-pharmacies" element={<FindPharmacies />} />
              <Route path="/print-pharmacies" element={<PrintPharmaciesPage />} />
            </Routes>
          </ExternalLinkModalProvider>
        </TooltipContainer>
      </OverlayContainer>
    </BrowserRouter>
  );
};
